<template>
  <div>
    <div class="title--area">
        <h2>{{ menuNm }}</h2>
    </div>
    <div class="data--container" v-resize @resize="onResize">
      <div class="flex--box flex--box--1_2 btn--on" style="width:50%;">
        <div class="btn--area space--between"></div>
        <div class="grid--area">
          <grid ref="grid1"
              :data="gridTreeProps.data"
              :columns="gridTreeProps.columns"
              :options="gridTreeProps.options"
              :language="'ko'"
              @click="gridClick">
          </grid>
        </div>
      </div>
      <div class="flex--box flex--box--1_2 btn--on flex--box--black" style="width:50%;">
        <div class="btn--area space--between">
          <button type="button" class="btn btn--black" @click="add">추가</button>
          <div class="btns">
            <button type="button" class="btn btn--white" @click="save">저장</button>
            <button type="button" class="btn btn--white" @click="del">삭제</button>
          </div>
        </div>
        <div class="grid--area">
          <grid ref="grid2"
              :data="gridProps.data"
              :columns="gridProps.columns"
              :options="gridProps.options"
              :language="'ko'"
              @check="gridCheck">
          </grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'tui-date-picker/dist/tui-date-picker.css'
import 'tui-time-picker/dist/tui-time-picker.css'
import { Grid } from '@toast-ui/vue-grid'
import mapMngApi from '@/api/admin/MapMng'
import mapTmeApi from '@/api/admin/MapTmeMng'

export default {
  name: 'MapTmeMng',
  components: {
    grid: Grid
  },

  data () {
    return {
      menuNm: this.$route.name,
      searchText: '',
      gridTreeProps: {
        data: [],
        columns: [
          {
            header: '목록ID',
            name: 'mapSysNo',
            width: 250
            // sortable: true
          },
          {
            header: '목록명',
            name: 'mapSysNm',
            width: 180
          },
          {
            header: '표시순번',
            name: 'dispOrdNo',
            width: 80,
            align: 'center'
          },
          {
            header: '주제명',
            name: 'categoryNm',
            width: 150
          },
          {
            header: '하위여부',
            name: 'lowerLevelYn',
            width: 80,
            align: 'center',
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '', value: '' },
                  { text: '예', value: 'Y' },
                  { text: '아니오', value: 'N' }
                ]
              }
            }
          },
          {
            header: '사용여부',
            name: 'useFlg',
            align: 'center',
            width: 80,
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '', value: '' },
                  { text: '예', value: 'Y' },
                  { text: '아니오', value: 'N' }
                ]
              }
            }
          },
          {
            header: '출처구분',
            name: 'srcCd',
            align: 'center',
            width: 100,
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '', value: '' },
                  { text: '승인통계', value: '1' },
                  { text: '지표통계', value: '2' },
                  { text: '행정통계', value: '3' },
                  { text: '기타', value: '4' }
                ]
              }
            }
          },
          {
            header: '출처번호',
            name: 'srcNo',
            width: 120,
            editor: 'text'
          },
          {
            header: '주기구분',
            name: 'tmeDivCd',
            align: 'center',
            width: 100,
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '', value: '' },
                  { text: '연', value: '1' },
                  { text: '분기', value: '2' },
                  { text: '월', value: '3' },
                  { text: '주', value: '4' },
                  { text: '수시', value: '5' }
                ]
              }
            }
          }
        ],
        options: {
          header: {
            height: 40
          },
          columnOptions: {
            resizable: true
          },
          bodyHeight: 580,
          selectionUnit: 'cell',
          scrollX: true,
          scrollY: true,
          editingEvent: 'dblclick',
          treeColumnOptions: {
            name: 'mapSysNo',
            useIcon: true,
            useCascadingCheckbox: false
          }
        }
      },
      gridProps: {
        data: [],
        columns: [
          // {
          //   header: '목록ID',
          //   name: 'mapSysNo',
          //   width: 120
          // },
          {
            header: '연도',
            name: 'year',
            width: 120,
            align: 'center',
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: []
              }
            },
            validation: { required: true, unique: true }
          },
          {
            header: '회차',
            name: 'tmeNo',
            width: 120,
            align: 'center',
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '1', value: '1' }
                ]
              }
            },
            validation: { required: true }
          },
          {
            header: '데이터여부',
            name: 'valSaveYn',
            width: 120,
            align: 'center',
            formatter: function (value) {
              return value.value === 'Y' ? '예' : '아니오'
            }
          },
          {
            header: '사용여부',
            name: 'useFlg',
            width: 120,
            align: 'center',
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '', value: '' },
                  { text: '예', value: 'Y' },
                  { text: '아니오', value: 'N' }
                ]
              }
            },
            validation: { required: true }
          }
        ],
        options: {
          rowHeaders: ['checkbox'],
          header: {
            height: 40
          },
          columnOptions: {
            resizable: true
          },
          bodyHeight: 550,
          selectionUnit: 'row',
          scrollX: true,
          scrollY: true,
          editingEvent: 'dblclick'
        }
      },
      rowKey: null,
      mapSysNo: '',
      attribute: {
        expanded: true
      }
    }
  },

  watch: {
    // 하위그리드 조회 시 떠있는 셀렉트박스 없애기
    mapSysNo: function () {
      const selectBox = document.getElementsByClassName('tui-select-box')
      for (let i = 0; i < selectBox.length; i++) {
        if (selectBox.length > 0) {
          selectBox[i].style.display = 'none'
        }
      }
    }
  },

  created () {
    this.searchGridTreeData() // 상위 그리드 조회

    // 연도 데이터 넣기
    const columns = this.gridProps.columns
    var year = new Date().getFullYear()
    for (let i = 0; i < columns.length; i++) {
      if (columns[i].header === '연도') {
        for (let j = year; j >= 2010; j--) {
          (columns[i].editor.options.listItems).push({ text: String(j), value: String(j) })
        }
      }
    }
  },

  methods: {
    onResize () {
      this.$refs.grid1.invoke('refreshLayout')
      this.$refs.grid2.invoke('refreshLayout')
    },
    // 상위 트리 그리드 조회
    async searchGridTreeData () {
      const params = {}

      const mapSysMngData = await mapMngApi.mapSysMngList(params)
      this.gridTreeProps.data = mapSysMngData

      if (this.gridTreeProps.data !== undefined) {
        this.$set(this.gridTreeProps.data[0], '_attributes', this.attribute) // 1depth 트리 expand 적용

        for (let i = 0; i < this.gridTreeProps.data[0]._children.length; i++) { // 2depth 까지 트리 expand 적용
          this.$set(this.gridTreeProps.data[0]._children[i], '_attributes', this.attribute)
        }

        this.$refs.grid1.invoke('resetData', this.gridTreeProps.data)

        // 왼쪽 그리드 컬럼 disabled 설정
        this.$refs.grid1.invoke('disableColumn', 'useFlg')
        this.$refs.grid1.invoke('disableColumn', 'lowerLevelYn')
        this.$refs.grid1.invoke('disableColumn', 'srcNo')
        this.$refs.grid1.invoke('disableColumn', 'srcCd')
        this.$refs.grid1.invoke('disableColumn', 'tmeDivCd')
      }
    },

    // 왼쪽 그리드 클릭 시 오른쪽 그리드 조회하기
    gridClick (ev) {
      if (ev.targetType === 'cell') {
        this.rowKey = ev.rowKey
        this.mapSysNo = this.$refs.grid1.invoke('getValue', ev.rowKey, 'mapSysNo')

        this.searchGridData()
      }
    },

    // 하위 그리드 조회
    async searchGridData () {
      const params = {
        mapSysNo: this.mapSysNo
      }
      const mapTmeMngData = await mapTmeApi.mapTmeMngList(params)
      this.gridProps.data = mapTmeMngData

      this.$refs.grid2.invoke('resetData', this.gridProps.data)
    },

    // 하위 그리드 row 추가
    add () {
      if (this.rowKey == null) {
        alert('목록을 선택해주세요.')
      } else {
        this.$refs.grid2.invoke('appendRow', { mapSysNo: this.mapSysNo }, { focus: false })
      }
    },

    // 하위 그리드 체크박스 선택 이벤트
    gridCheck (ev) {
      if (this.$refs.grid2.invoke('getValue', ev.rowKey, 'year') == null) {
        this.$refs.grid2.invoke('removeRow', ev.rowKey)
      }
    },

    // 그리드 내 입력, 수정 event
    async save () {
      if (!this.gridRequiredCheck()) return // 필수항목 값 체크

      const params = this.$refs.grid2.invoke('getModifiedRows')
      if (params.createdRows.length === 0 && params.updatedRows.length === 0) { // 추가 또는 수정된 row가 없다면 이벤트 발생 없이 return
        return
      }

      if (this.checkYearData()) {
        const params = this.$refs.grid2.invoke('getModifiedRows') // createdRows, updatedRows, deletedRows
        if (window.confirm('저장하시겠습니까?')) {
          const result = await mapTmeApi.saveMapTmeMng(params)

          if (result.result) {
            alert('저장되었습니다.')
            this.searchGridData()
          } else {
            alert('오류가 발생했습니다. 다시 시도해주세요.')
          }
        }
      }
    },

    gridRequiredCheck () { // 필수 입력값 체크
      const rowCnt = this.$refs.grid2.invoke('getRowCount')
      for (let i = 0; i < rowCnt; i++) {
        const year = this.$refs.grid2.invoke('getRowAt', i).year
        const tmeNo = this.$refs.grid2.invoke('getRowAt', i).tmeNo
        const useFlg = this.$refs.grid2.invoke('getRowAt', i).useFlg

        if (year == null || year === '') {
          alert('연도를 입력해주세요!')
          this.$refs.grid2.invoke('focus', i, 'year')
          return false
        } else if (tmeNo == null || tmeNo === '') {
          alert('회차를 입력해주세요!')
          this.$refs.grid2.invoke('focus', i, 'tmeNo')
          return false
        } else if (useFlg == null || useFlg === '') {
          alert('사용여부를 입력해주세요!')
          this.$refs.grid2.invoke('focus', i, 'useFlg')
          return false
        }
      }

      return true
    },

    // 그리드 내 연도 중복 체크
    checkYearData () {
      const yearDataArr = []
      const rowCnt = this.$refs.grid2.invoke('getRowCount')

      for (let i = 0; i < rowCnt; i++) { // 그리드2의 row갯수만큼 for문
        const yearValue = this.$refs.grid2.invoke('getValue', i, 'year')
        if (yearDataArr.indexOf(yearValue) < 0) { // yearDataArr에 그리드의 연도가 없으면
          yearDataArr.push(yearValue) // yearDataArr에 그리드의 연도 넣기
        } else {
          alert('중복된 연도가 존재합니다.')
          return false
        }
      }
      return true
    },

    // 그리드 내 삭제 event
    async del () {
      const params = this.$refs.grid2.invoke('getCheckedRows') // check 된 row만 삭제

      if (params.length > 0) {
        if (window.confirm('선택한 연도와 회차의 수치 데이터가 있을 경우 동시에 삭제됩니다.\n계속하시겠습니까?')) {
          const result = await mapTmeApi.deleteMapTmeMng(params)

          if (result.result) {
            alert('삭제되었습니다.')
            this.searchGridData()
          } else {
            alert('오류가 발생했습니다. 다시 시도해주세요.')
          }
        }
      } else {
        alert('삭제하실 항목을 선택해주세요.')
      }
    }
  }
}
</script>

<style scoped>

</style>
